// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1TJWe","clinicsSelect":"TableHeading_clinicsSelect__2cEoB"};